module.exports = __webpack_public_path__ + "356f46a22e447a8ff87bdbafa237c157.jpg";